import React from 'react';
import { useNavigate } from 'react-router-dom';
import { XCircle, ArrowLeft, ArrowRight } from 'lucide-react';

const PaymentCancel = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-[var(--main-bg)] flex items-center justify-center p-4">
      <div className="max-w-lg w-full bg-[var(--surface)] border-2 border-[var(--border-default)] p-12 text-center" data-testid="payment-cancel-page">
        <div className="w-20 h-20 bg-[var(--surface-alt)] border-2 border-[var(--border-default)] rounded-full flex items-center justify-center mx-auto mb-6">
          <XCircle size={40} className="text-[var(--text-secondary)]" />
        </div>

        <h2 className="text-3xl font-black mb-3" style={{ fontFamily: "'Space Grotesk', sans-serif" }}>
          Payment Cancelled
        </h2>
        <p className="text-lg text-[var(--text-secondary)] mb-8">
          No worries — your ideas are still safe. You can upgrade anytime.
        </p>

        <div className="bg-gradient-to-br from-[#007AFF]/10 to-[#FFD60A]/10 border-2 border-[var(--border-default)] p-6 mb-8 text-left">
          <h3 className="font-bold mb-3" style={{ fontFamily: "'Space Grotesk', sans-serif" }}>
            Still on the fence? Remember:
          </h3>
          <ul className="space-y-2 text-sm text-[var(--text-secondary)]">
            <li className="flex items-start gap-2">
              <span className="text-[var(--secondary)] font-bold mt-0.5">-</span>
              <span>Founding Member gets <strong>lifetime Pro</strong> for just $49</span>
            </li>
            <li className="flex items-start gap-2">
              <span className="text-[var(--secondary)] font-bold mt-0.5">-</span>
              <span>Unlimited AI-powered idea enhancement</span>
            </li>
            <li className="flex items-start gap-2">
              <span className="text-[var(--secondary)] font-bold mt-0.5">-</span>
              <span>Limited to the first 500 members</span>
            </li>
          </ul>
        </div>

        <div className="flex flex-col sm:flex-row gap-3">
          <button
            onClick={() => navigate('/dashboard')}
            data-testid="back-to-dashboard-btn"
            className="flex-1 flex items-center justify-center gap-2 px-6 py-3 border-2 border-[var(--border-default)] font-bold hover:bg-[var(--surface-alt)] transition-colors"
          >
            <ArrowLeft size={16} /> Dashboard
          </button>
          <button
            onClick={() => navigate('/pricing')}
            data-testid="back-to-pricing-btn"
            className="flex-1 bg-[var(--obsidian)] text-white font-bold px-6 py-3 border-2 border-[var(--border-default)] hover:translate-x-[2px] hover:translate-y-[2px] transition-transform flex items-center justify-center gap-2"
          >
            View Plans <ArrowRight size={16} />
          </button>
        </div>
      </div>
    </div>
  );
};

export default PaymentCancel;
